/** Colonne finali: algoritmo pinnato nel brief (§3). */
export function balancedColumns(items: ('full' | 1 | 2 | 3)[], width: number, min: number, max: number, gap: number): number {
  if (items.length === 0) return 1
  const fit = Math.min(max, Math.max(1, Math.floor((width + gap) / (min + gap))))
  const count = (cols: number) => items.reduce<number>((s, it) => s + (it === 'full' ? cols : Math.min(it, cols)), 0)
  let cols = fit
  for (let i = 0; i < 4; i += 1) {
    const n = count(cols)
    let c = Math.min(fit, n)
    const rows = Math.ceil(n / c)
    c = Math.ceil(n / rows)
    if (c === cols) break
    cols = c
  }
  return Math.max(1, cols)
}
